import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "../errorPopup/errorPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import CloseButton from "../../closeButton/closeButton";

function CallEndedNotificationPopup({
  onClose,
  by,
}: IPopupWithoutProps & { by: string }) {
  return (
    <article className={popupStyles.popup}>
      <CloseButton onClick={onClose} />
      <h2 className={popupStyles.popup__title}> {t('THE_CONVERSATION_ENDED_BY')}</h2>
      <h2 className={popupStyles.popup__title}>{by}</h2>
      <img
        src={doctor}
        alt={t('IMAGE_OF_VENUS')}
        className={popupStyles.popup__img}
      />
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >
        {t('APPROVAL')}</button>
    </article>
  );
}

export default CallEndedNotificationPopup;
